// extracted by mini-css-extract-plugin
module.exports = {"root":"HeaderMenu_root__3zRun","arrowUp":"HeaderMenu_arrowUp__MWGXe"};